module.exports = __webpack_public_path__ + "static/media/orange_circle_and_lines.92613d98.svg";